import React, { Component } from 'react';
import { DISPATCH_ID } from '../libs/utils/Const';
import { connect } from 'react-redux';
import '../css/dataTables.css';
import $ from 'jquery';
import AreYouAgreeModal from './AreYouAgreeModal';


class PaymentInvoiceCreditPoinstCardModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeModalInvoiceCredit = async () => {
        const { GetAllConfiguration } = this.props;
        await GetAllConfiguration()
        $('#paymentInvoiceCreditPoinstCard').modal('hide');
    };

    closeAction = () => {
        const { cleanData } = this.props;
        $('#paymentInvoiceCreditPoinstCard').on('hide.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const {
            PointsCardModel,
            change_InvoiceCredit,
            activeShowAreYouAgreeModal_InvoiceCredit,
            showAreYouAgreeModal_InvoiceCredit,
            CloseShowAreYouAgreeModal_InvoiceCredit,
            Update_InvoiceCredit,
        } = this.props;

        return (

            <>
                <div className="modal fade bd-example-modal-md modal-open scroll"
                    id="paymentInvoiceCreditPoinstCard"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true">

                    <div className="modal-dialog modal-md modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white"
                                style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">
                                    Configuración Opción de Pago
                                </h4>
                                <button type="button" className="close" onClick={this.closeModalInvoiceCredit} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">
                                        &times;
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Pago de Facturas de crédito (con PTOS)</span>
                                                            </div>
                                                            <select className="form-control"
                                                                // disabled={(action == 2 && !editMode) ? true : false}
                                                                onChange={change_InvoiceCredit}
                                                                value={PointsCardModel.InvoiceCredit} >
                                                                <option value="">-Selecciona-</option>
                                                                <option value="N">NO</option>
                                                                <option value="Y">SI</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModalInvoiceCredit} >Cerrar</button>
                                <button type="button" className="btn botonCorrect text-black" onClick={activeShowAreYouAgreeModal_InvoiceCredit} >Guardar Cambios</button>
                            </div>
                        </div>
                    </div>
                </div>
                {showAreYouAgreeModal_InvoiceCredit &&
                    <AreYouAgreeModal
                        mensaje={`¿Estás seguro que deseas ${PointsCardModel.InvoiceCredit === 'Y' ? 'habilitar' : 'deshabilitar'} el pago de facturas de crédito con puntos?`}
                        accept={Update_InvoiceCredit}
                        cancel={CloseShowAreYouAgreeModal_InvoiceCredit}
                    />
                }
            </>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentInvoiceCreditPoinstCardModal);